import { WEBSITE_DETAILS } from "@/config";
import { ROUTES } from "@/constant/routes";
import { Mail, MapPin, PhoneCall, Globe, Search, PaintBucket } from "lucide-react";

export const SERVICES_LINKS = [
    { label: "Web Design", href: ROUTES.HOME, external: false },
    {
        label: "Reepank Solutions",
        href: WEBSITE_DETAILS.mainWebsite,
        external: true,
    },
    {
        label: "Portfolio",
        href: WEBSITE_DETAILS.portfolioURL,
        external: true,
    },
    {
        label: "Mobile App Development",
        href: WEBSITE_DETAILS.mobileAppWebsite,
        external: true,
    },
    {
        label: "Web Development",
        href: WEBSITE_DETAILS.webAppeWebsite,
        external: true,
    },
];

export const COMPANY_LINKS = [
    {
        label: "Portfolio",
        href: ROUTES.PORTFOLIO,
        external: false,
        isRoute: true,
    },
    { label: "Blogs", href: WEBSITE_DETAILS.blogUrl, external: true, isRoute: false },
    { label: "About ", href: ROUTES.ABOUT, external: false, isRoute: true },
    { label: "Contact", href: ROUTES.CONTACT, external: false, isRoute: true },
];


export const FOOTER_LINKS = [
    { to: ROUTES.PRIVACY_POLICY, label: "Privacy Policy" },
    { to: ROUTES.TERMS_OF_SERVICE, label: "Terms of Service" },
];

export const CONTACT_ITEMS = [
    { icon: Mail, value: WEBSITE_DETAILS.contact.email },
    { icon: PhoneCall, value: WEBSITE_DETAILS.contact.phone },
    { icon: MapPin, value: WEBSITE_DETAILS.contact.address },
];




export const BADGE_DATA = [
    {
        label: "Web Design",
        icon: Globe,
        className: "text-white bg-blue-600 hover:bg-blue-700 flex items-center gap-0.5 text-[10px] font-semibold",
    },
    {
        label: "UIUX",
        icon: PaintBucket,
        className: "text-white bg-pink-600 hover:bg-blue-700 flex items-center gap-0.5 text-[10px] font-semibold",
    },
    {
        label: "SEO",
        icon: Search,
        className: "text-white bg-purple-600 hover:bg-purple-700 flex items-center gap-0.5 text-[10px] font-semibold",
    },
    {
        label: "Mobile App Design",
        icon: PaintBucket,
        className: "text-white bg-orange-600 hover:bg-orange-700 flex items-center gap-0.5 text-[10px] font-semibold",
    },
];
